<!--
 * @Author: vince
 * @Date: 2021-09-05 16:03:44
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-05 11:45:18
 * @Description:
-->
<template>
  <el-container>
    <el-header class="head">
      <el-menu
        :default-active="activeIndex"
        class="reportTab"
        mode="horizontal"
        @select="onTabClick"
      >
        <el-menu-item index="getTeacherProPlanningInfo">专业规划</el-menu-item>
        <el-menu-item index="getTeacherProSummaryInfo">规划达成小结</el-menu-item>
      </el-menu>
    </el-header>
    <el-main>
      <div class="pa-md bg-white">
        <el-form class="full-width mb-sm" :model="teacherPlanForm">
          <div class="filter-bar pa-none">
            <el-form-item class="mb-none" label="学年">
              <school-year-selector checkAll v-model="teacherPlanForm.schoolYear" @change="refresh"></school-year-selector>
            </el-form-item>
            <el-form-item class="mb-none" label="校区">
              <school-selector checkAll v-model="teacherPlanForm.schoolCode" @change="refresh"></school-selector>
            </el-form-item>
            <el-form-item class="mb-none" label="状态">
              <dicSelector
                v-model="teacherPlanForm.isComplete"
                size="small"
                checkAll
                dicType="complete"
                @change="refresh"
              ></dicSelector>
            </el-form-item>
            <!-- <el-form-item class="mb-none">
                  <el-input
                    size="small"
                    v-model="teacherInfoForm.keyword"
                    @input="() => refreshTeachrInfo()"
                    clearable
                    placeholder="搜索"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
            </el-form-item>-->
            <div class="space"></div>
          </div>
        </el-form>
        <el-table :data="teacherPlanList" header-cell-class-name="tbh" style="width: 100%">
          <el-table-column prop="teacherNum" label="师训号" align="center">
          </el-table-column>
          <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="schoolName" label="校区" align="center">
            <!-- <template slot-scope="scope">
              <span
                v-if="scope.row.teacherArchivesDTO"
              >{{ scope.row.teacherArchivesDTO.schoolName }}</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="editor" label="完成状态" align="center"></el-table-column>
          <el-table-column prop="createTime" label="完成时间" align="center"></el-table-column>

          <pagination
            v-if="teacherPlanList.length > 0"
            class="mb-md mr-md"
            slot="append"
            :pageObj="teacherPlanForm"
            @handleSizeChange="firstHandleSizeChange"
            @handleCurrentChange="firstTeacherPageChange"
          ></pagination>
        </el-table>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import DicSelector from "../../components/school/dicSelector.vue";
import pagination from "../../components/Pagination.vue";
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import SchoolSelector from "../../components/school/schoolSelector.vue";
import { postData, postJson, getData } from "../../http/fetch.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "teacherPlant",
  components: {
    schoolYearSelector,
    SchoolSelector,
    pagination,
    DicSelector,
  },
  data() {
    return {
      loading: false,
      statusList: [],
      teacherPlanList: [],
      activeIndex: "getTeacherProPlanningInfo", //second
      teacherPlanForm: {
        isComplete: {
          dicCode: ''
        },
        size: 10,
        current: 1,
        total: 0,
        keyword: null,
        schoolYear: null,
        school: null,
        schoolCode: null,
      },
    };
  },

  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["schoolCodes", "schoolList"]),
  },
  filters: {
    statusFormatter(s) {
      let result = this.statusList.find(f => { f.dicCode == s })
      if (result) {
        return result.dicName
      } else {
        return s
      }
    },
  },

  created() {
    this.getDic("complete").then((res) => {
      this.statusList = res;
    });
  },
  mounted() {
    this.getData();
  },
  methods: {

    getData() {
      this.loading = true;
      postJson(`/teacherDevelopment/${this.activeIndex}`, {
        "pageNum": this.teacherPlanForm.current,
        "pageSize": this.teacherPlanForm.size||10,
        "schoolCode": this.teacherPlanForm.schoolCode?this.teacherPlanForm.schoolCode.schoolCode:null,
        "schoolYear": this.teacherPlanForm.schoolYear,
        "isComplete": this.teacherPlanForm.isComplete.dicCode,
      }).then(res => {
        if (res.records && res.records.length > 0) {
          this.teacherPlanList = res.records;
        } else {
          this.teacherPlanList = []
        }
        this.teacherPlanForm.size = res.size
        this.teacherPlanForm.current = res.current
        this.teacherPlanForm.total = res.total

      }).catch(e => {
        this.teacherPlanList = []
      }).finally(() => {
        this.loading = false
      })
    },
    getDic(dicType) {
      return new Promise((resolve, reject) => {
        getData("/core/dic/getDictionaryList", {
          dicType,
        }).then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName,
              };
            });
            resolve(res);
          } else {
            reject();
          }
        });
      });
    },
    onTabClick(index, indexPath) {
      this.activeIndex = index;
      this.teacherPlanList = [];
      this.teacherPlanForm.current = 1;
      this.getData();
    },

    refresh() {
      this.teacherPlanForm.current=1;
      this.getData();
    },

    firstHandleSizeChange(pageSize) {
      this.teacherPlanForm.current = 1;
      this.teacherPlanForm.size = pageSize;
      this.getData();
    },
    firstTeacherPageChange(pageIndex) {
      this.teacherPlanForm.current = pageIndex;
      this.getData();
    },





  },
};
</script>

<style lang="less">
.notab {
  .el-tabs__header {
    display: none;
  }
}
.photo {
  width: 60px;
  height: 60px;
}
.awardTit {
  text-align: center;
  font-size: 20px;
  font-weight: 540;
  color: #000;
}
.no-more {
  text-align: center;
  margin-top: 50px;
  font-weight: 540;
}
.filter-row,
.my-filter {
  align-items: center;
  .score {
    color: @color;
    display: block;
    vertical-align: middle;
    height: 32px;
    line-height: 32px;
    margin-right: 25px;
    font-size: 18px;
    min-width: 135px;
  }
  .se-nake {
    font-size: 15px;
    height: 32px;
    line-height: 32px;
  }
  .el-input-group__append {
    cursor: pointer;
    background: @color;
    color: #fff;
  }
}
</style>
